import React from 'react';

import cn from 'classnames';
import './style.scss';

interface IProps {
  white?: boolean;
  className?: string;
  bottom?: boolean;
  small?: boolean;
}

function Loader({ white, className, bottom, small }: IProps) {
  return (
    <div
      className={cn(
        'Loader',
        className,
        white && 'Loader--white',
        bottom && 'Loader--bottom',
        small && 'Loader--small',
      )}
      data-testid="Loader"
    />
  );
}

export default Loader;
